import React from "react";
import Context from "../../../Context";
import EssenceReference from "../../Essence/EssenceReference";
import Blocker from "../../Misc/Blocker";
import MaintStructTree from "./MaintStructTree";
import { Link } from "react-router-dom";

export default class MaintStruct extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      showReference: false,
      structItems: null,
      structItemsSearchDefault: [
        {
          lstr: "(",
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
        },
        {
          field: "typecode",
          compare: "EQL",
          value: "maintenance.structure",
          rstr: ")",
        },
      ],
    };
  }

  componentDidMount() {
    this.loadStruct();
  }

  loadStruct = async () => {
    this.setState({ pending: true });

    let structItems = await this.context.api.qoo(
      `/structure/list`,
      { search: this.state.structItemsSearchDefault },
      undefined,
      undefined,
      undefined,
      "node",
      "sequence"
    );

    this.setState({ pending: false, structItems });
  };

  toggleReference = () => {
    this.setState((state) => {
      return { showReference: !state.showReference };
    });
  };

  render() {
    return (
      <>
        <EssenceReference
          essence="structure"
          sort="sequence"
          draggable
          title="Виды и типы ТО"
          showDescription
          structure
          editOnDblClick
          show={this.state.showReference}
          onHide={() => {
            this.toggleReference();
            this.loadStruct();
          }}
          forceType="maintenance.structure"
        />
        <Blocker spinnerFixed hAuto on={this.state.pending}>
          {this.props.manageStructure && (
            <div className="text-right mb-4">
              <button
                className="btn w-100 btn-light "
                onClick={this.toggleReference}
              >
                <i className="fa fa-cogs"></i> Настроить виды и типы ТО
              </button>
            </div>
          )}
          {this.state.structItems ? (
            <>
              {this.props.shipId && this.props.shipId !== "any" && (
                <div
                  className={`p-1  bg-hover-light ${
                    this.props.structureId === "any" && "bg-light"
                  }`}
                >
                  <Link
                    className="text-dark d-block "
                    to={`/maint/any/${this.props.shipId}`}
                  >
                    <i className="fa fa-list mr-3"></i> Все
                  </Link>
                </div>
              )}
              <MaintStructTree items={this.state.structItems} {...this.props} />
            </>
          ) : null}
        </Blocker>
      </>
    );
  }
}
